import React, { useState, useEffect, useCallback } from 'react';
import './WalletConnect.css';

const WalletConnect = () => {
  const [walletAddress, setWalletAddress] = useState(null);
  const [tokenBalance, setTokenBalance] = useState('0.00');
  const [showModal, setShowModal] = useState(false);
  const [showDisconnectPrompt, setShowDisconnectPrompt] = useState(false);

  const contractAddress = '4UTEFQjNMvfQF5NT8mVfXdMAKoL7hS7i9U4mMVAzpump';
  const raydiumLink =
    'https://raydium.io/swap/?outputMint=4UTEFQjNMvfQF5NT8mVfXdMAKoL7hS7i9U4mMVAzpump';

  const walletOptions = [
    { name: 'Phantom', method: 'solana' },
    { name: 'SolFlare', method: 'solflare' },
  ];

  const connectWallet = async (walletMethod) => {
    if (window[walletMethod]) {
      try {
        const response = await window[walletMethod].connect();
        setWalletAddress(response.publicKey.toString());
        setShowModal(false); // Close modal after successful connection
      } catch (err) {
        console.error(`Connection to ${walletMethod} wallet failed:`, err);
      }
    } else {
      alert(`${walletMethod} Wallet is not installed.`);
    }
  };

  const disconnectWallet = () => {
    setWalletAddress(null);
    setTokenBalance('0.00');
    setShowDisconnectPrompt(false);
  };

  const fetchTokenBalance = useCallback(async () => {
    if (!walletAddress) return;

    try {
      const accounts = await window.solana.request({
        method: 'getTokenAccountsByOwner',
        params: [
          walletAddress,
          { mint: contractAddress },
          { encoding: 'jsonParsed' },
        ],
      });

      if (accounts.result?.value?.length > 0) {
        const accountInfo = accounts.result.value[0];
        const balance =
          accountInfo.account.data.parsed.info.tokenAmount.uiAmount || 0.0;
        setTokenBalance(balance.toFixed(2));
      } else {
        setTokenBalance('0.00');
      }
    } catch (err) {
      console.error('Failed to fetch token balance:', err);
      setTokenBalance('0.00');
    }
  }, [walletAddress, contractAddress]);

  useEffect(() => {
    if (walletAddress) fetchTokenBalance();
  }, [walletAddress, fetchTokenBalance]);

  return (
    <div className="wallet-connect">
      {walletAddress ? (
        <>
          <button
            className="wallet-button connected"
            onClick={() => setShowDisconnectPrompt(!showDisconnectPrompt)}
          >
            Connected
          </button>
          {showDisconnectPrompt && (
            <div className="disconnect-prompt">
              Disconnect? <br />
              <span
                className="disconnect-details"
                onClick={disconnectWallet}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                Tap to Disconnect.
              </span>
              <br />
              <span className="disconnect-details">
                Tap anywhere else to disregard.
              </span>
            </div>
          )}
          <div className="wallet-info">
            <p>Balance: {tokenBalance} $1</p>
            {tokenBalance === '0.00' && (
              <p className="no-token-info">
                <a
                  href={raydiumLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="buy-link"
                >
                  Get $1 Tokens
                </a>
              </p>
            )}
          </div>
        </>
      ) : (
        <>
          <button className="wallet-button" onClick={() => setShowModal(true)}>
            Connect Wallet
          </button>
        </>
      )}

      {showModal && (
        <div className="wallet-modal" onClick={() => setShowModal(false)}>
          <div className="wallet-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Choose Your Wallet</h3>
            <ul>
              {walletOptions.map((wallet) => (
                <li key={wallet.name} onClick={() => connectWallet(wallet.method)}>
                  {wallet.name}
                </li>
              ))}
            </ul>
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletConnect;
